<template>
    <svg id="Layer_1" :height="height" :width="height" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path fill="none" d="M0,0H48V48H0Z"/>
        <path fill="#799cfb"
              d="M40,8H8a4,4,0,0,0-4,4L4,36a4,4,0,0,0,4,4H40a4,4,0,0,0,4-4V12A4,4,0,0,0,40,8Zm0,8L24,26,8,16V12L24,22,40,12Z"/>
    </svg>
</template>

<script>
    export default {
        name: "ILetter",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
